import React from 'react';
import { DgtPdOrderPicklist } from '../models';

// Define the shape of the context state
interface PicklistContextState {
  header: DgtPdOrderPicklist;
  items: DgtPdOrderPicklist[];
  comments: DgtPdOrderPicklist[];
  mutateHeader: (hd : DgtPdOrderPicklist) => void;
  // setPicklists: (itms : DgtPdOrderPicklist[]) => void; // dont need now
}

// Create the context with a default value
const PicklistContext = React.createContext<PicklistContextState | undefined>(undefined);

export default PicklistContext;